import type { IconProps } from '../types/IconProps.ts';
export const UserLock: IconProps = {
    name: 'UserLock',
    children: [
        `<path d="M11 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />`,
        `<path d="M14.15 12.64A8 8 0 0 0 3 20M21.61 18H15.4c-.22 0-.39.16-.39.36v3.28c0 .2.17.36.39.36h6.22c.22 0 .39-.16.39-.36v-3.28c0-.2-.17-.36-.39-.36ZM17 18v-1.33c0-.92.67-1.67 1.5-1.67s1.5.75 1.5 1.67V18" />`,
    ]
};